<template>
    <div>
        <div class="tabs is-centered is-small">
            <ul>
                <template v-if="registrationTabs.length > 1">
                    <li
                        v-for="regTab in registrationTabs"
                        :key="regTab.name"
                        @click="tab=regTab.name"
                        :class="{'is-active': tab==regTab.name}"
                    >
                        <a>{{$t(regTab.label)}}</a>
                    </li>
                </template>
            </ul>
        </div>
        <div class="registration">
            <div v-show="tab=='registration-phone' && registrationStep==1">
                <registration-by-phone
                    :go-to-step2="(regData) => { $refs.registrationByPhoneConfirmation.setRegData(regData); registrationStep = 2; }"
                />
            </div>
            <div v-show="tab=='registration-phone' && registrationStep==2">
                <registration-by-phone-confirmation ref="registrationByPhoneConfirmation" />
            </div>
            <div v-show="tab=='registration-login-pass'">
                <registration-by-login />
            </div>
            <div v-show="tab=='registration-email' && registrationStep==1">
                <registration-by-email
                    :go-to-step2="(regData) => { $refs.registrationByEmailConfirmation.setRegData(regData); registrationStep = 2; }"
                />
            </div>
            <div v-show="tab=='registration-email' && registrationStep==2">
                <registration-by-email-confirmation ref="registrationByEmailConfirmation" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import RegistrationByLogin from './registration-by-login';
import RegistrationByEmail from './registration-by-email';
import RegistrationByEmailConfirmation from './registration-by-email-confirmation';
import RegistrationByPhone from './registration-by-phone';
import RegistrationByPhoneConfirmation from './registration-by-phone-confirmation';

const registrationTypes = [
    { type: 'phone', name: 'registration-phone', label: 'components.common.quick-login-reg.registration.by phone' },
    {
        type: 'login',
        name: 'registration-login-pass',
        label: 'components.common.quick-login-reg.registration.by login'
    },
    { type: 'email', name: 'registration-email', label: 'components.common.quick-login-reg.registration.by email' }
];

export default {
    name: 'registration-home',
    components: {
        RegistrationByLogin,
        RegistrationByEmail,
        RegistrationByEmailConfirmation,
        RegistrationByPhone,
        RegistrationByPhoneConfirmation
    },
    data() {
        return {
            tab: 'registration-phone',
            registrationStep: 1
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        registrationTabs() {
            let defaultRegistrationType = this.client.registration.defaultRegistrationType || this.client.registration.registrationTypes[0];
            let q = registrationTypes
                .filter(registrationType => this.client.registration.registrationTypes.some(type => type === registrationType.type))
                .sort((a, b) => (a.type == defaultRegistrationType ? -1 : ('' + a.type.attr).localeCompare(b.type.attr)));

            return q;
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/quick-login-reg/registration.vue